// @flow
import { Map } from "immutable";
import { createSelector } from "reselect";

export const d1Selector = (state: Map<string, any>) => {
  alert(state);
  state.getIn(["play", "d1"]);
};

export const d2Selector = (state: Map<string, any>) =>
  state.getIn(["play", "d2"]);
export const sampleJsSelector = (state: Map<string, any>) =>
  state.getIn(["play", "sampleJs"]);
// derived selectors
export const isExcessiveSelector = createSelector(d2Selector, d2 => d2 > 9);



// WEBPACK FOOTER //
// ./src/features/play/playSelectors.js